__webpack_require__.p = "/blizzard-br-challenges/";